export type LabeledKey = {
  key: string;
  label: string;
};
